import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CHECKOUT_URL, IMAGES } from '../data/site';
import { Wordmark } from './Wordmark';
const trust = ['Instant digital access', 'One-time payment', 'No subscription', '7-day guarantee'];
export function Hero() {
  return <header className="w-full bg-cream px-5 pb-12 pt-8 sm:px-6 sm:pb-16 sm:pt-10" data-id="element-152" data-mp="9ih0dmtnseqi">
      <div className="mx-auto max-w-3xl text-center" data-id="element-153" data-mp="4jm5hmif2zq1">
        <Wordmark data-id="element-154" data-mp="129qs1epkbdkp" />

        <p className="mt-7 inline-block rounded-full border border-navy/15 bg-white px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-[0.12em] text-navy/70" data-id="element-155" data-mp="128yxm77pblw0">
          For healthcare professionals
        </p>

        <h1 className="mt-4 font-serif text-[34px] font-bold leading-[1.08] tracking-[-0.01em] text-navy sm:text-5xl md:text-[56px]" data-id="element-156" data-mp="s9giq56neqat">
          Find the Clinical Pathway You Need in{' '}
          <span className="italic text-gold" data-id="element-157" data-mp="3d33fj0i70xlt">5 Minutes</span> or Less
        </h1>

        <p className="mx-auto mt-5 max-w-xl text-[16px] leading-relaxed text-navy/70 sm:text-lg" data-id="element-158" data-mp="381e6fqej6u0d">
          Stop searching through multiple menopause guidelines just to answer one clinical question.
          Menopause Decision Desk™ turns complex menopause evidence into a structured, visual decision
          system.
        </p>

        <div className="-mx-1 mt-8 sm:mx-0" data-id="element-159" data-mp="39cfmh57cz9w5">
          <img src={IMAGES.mainMockup} alt="The complete Menopause Decision Desk™ — six clinical tomes, five bonuses, tablet and phone access" className="mx-auto w-full max-w-2xl" width={1080} height={1080} data-id="element-160" data-mp="3e8mtl1bhqrfo" />
        </div>

        <p className="mx-auto mt-2 max-w-md font-serif text-[15px] font-bold leading-snug text-navy sm:text-lg" data-id="element-161" data-mp="2qkdba9dhklta">
          6 Clinical Decision Tomes · 300+ Decision Tools · 5 Premium Bonuses
        </p>

        <div className="mx-auto mt-7 max-w-md" data-id="element-162" data-mp="2hind8kp3momj">
          <a id="hero-cta" href={CHECKOUT_URL} className="group flex w-full items-center justify-center rounded-full bg-navy px-6 py-[1.05rem] text-center text-[15px] font-extrabold uppercase leading-tight tracking-[0.05em] text-cream shadow-[0_16px_36px_-16px_rgba(22,35,63,0.9)] transition-[background-color,transform] duration-200 ease-out hover:bg-navy-light active:scale-[0.98] sm:text-base" data-id="element-163" data-mp="2hjym2yxeimki">
            Get the complete Decision Desk™
          </a>
          <p className="mt-3 text-[13px] font-semibold text-navy/70" data-id="element-164" data-mp="db2d7as4g7l5">
            Instant Digital Access · One-Time Payment · <span className="text-gold" data-id="element-165" data-mp="1ayjf37ngf433">$27 USD</span>
          </p>
        </div>

        <ul className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-center gap-x-4 gap-y-2" data-id="element-166" data-mp="15zq35jntfl51">
          {trust.map(item => <li key={item} className="flex items-center gap-1.5 text-[12.5px] font-semibold text-navy/60" data-id="element-167" data-mp="x1nwanhehy9u">
              <CheckIcon className="h-3.5 w-3.5 shrink-0 text-gold" aria-hidden="true" data-id="element-168" data-mp="3lt76ct9j5vvb" />
              {item}
            </li>)}
        </ul>
      </div>
    </header>;
}